import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { Link, NavLink, Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Navbar, Nav, Offcanvas, Button } from "react-bootstrap";
import {
  FaDice,
  FaHorse,
  FaHorseHead,
  FaRegEye,
  FaRocket,
  FaTrophy,
  FaUser,
} from "react-icons/fa";
import { BiCricketBall, BiFootball, BiSolidTennisBall } from "react-icons/bi";
import { ImSpades } from "react-icons/im";
import { PiMonitorPlay } from "react-icons/pi";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css";
import "../../../src/App.css";
import LoginPopup from "../LoginPopup/LoginPopup";
import AccountStatus from "../AccountStatus/AccountStatus";
import { useNavigate } from "react-router-dom";
// import Helper from "../../helper";
import { useAuth } from "../AuthContext";
import Appconfig from "../../config/config";
import axios from "axios";
import {
  getOpenBets as fetchOpenBetsApi,
} from "../../services/users";
import { useDispatch, useSelector } from "react-redux";
import { emptyUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import SignUp from "../SignUp/SignUp";
// import Login from "../Login/Login";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { toast } from "react-toastify";
import UserAutoLogout from "../userAutoLogout";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import MyMarketPopup from "../MyMarketPopup/MyMarketPopup";
import ScrollGames from "../ScrollGames/ScrollGames";
import SideMenu from "../SideMenu/SideMenu";
import RightMenu from "../RightMenu/RightMenu";
import { getAllEvents } from "../../redux/slice/event/eventSlice";
import RulesModal from "../Rules/Rules";

const DESKTOP_NAV_ITEMS = [
  {
    id: "home",
    label: "HOME",
    path: "/",
  },
  {
    id: "lottery",
    label: "LOTTERY",
    path: "/lottery",
  },
  {
    id: "cricket",
    label: "CRICKET",
    eventType: 4,
  },
  {
    id: "tennis",
    label: "TENNIS",
    eventType: 2,
  },
  {
    id: "football",
    label: "FOOTBALL",
    eventType: 1,
  },
  {
    id: "table-tennis",
    label: "TABLE TENNIS",
    eventType: 8,
  },

  // Casino items
  {
    id: "baccarat",
    label: "BACCARAT",
    wcoGame: {
      providerCode: "SN",
      gameCode: "VBAC20",
    },
  },
  {
    id: "32-cards",
    label: "32 CARDS",
    wcoGame: {
      providerCode: "SN",
      gameCode: "VC32",
    },
  },
  {
    id: "teenpatti",
    label: "TEENPATTI",
    wcoGame: {
      providerCode: "DC",
      gameCode: "600011",
    },
  },
  {
    id: "poker",
    label: "POKER",
    wcoGame: {
      providerCode: "SPB",
      gameCode: "poker",
    },
  },
  {
    id: "lucky-7",
    label: "LUCKY 7",
    wcoGame: {
      providerCode: "DC",
      gameCode: "150087",
    },
  },
  {
    id: "crash",
    label: "CRASH",
    crash: true,
    wcoGame: {
      providerCode: "SPB",
      gameCode: "aviator",
    },
  },
];

// Desktop green navigation kin pages par show hogi
const DESKTOP_NAV_VISIBLE_ROUTES = [
  "/",
  "/home",
  "/dashboard",
  "/all-games-lobby",
  "/matchupdates",
  "/accountstatement",
  "/account-statement",
  "/deposit",
  "/withdraw",
  "/add-withdraw-method"
];

// Live matches kin pages par show honge
const LIVE_MATCHES_VISIBLE_ROUTES = [
  "/",
  "/home",
  "/dashboard",
];

const isRouteVisible = (currentPath, visibleRoutes) => {
  return visibleRoutes.some((route) => {
    // Root route sirf exact "/" par match honi chahiye
    if (route === "/") {
      return currentPath === "/";
    }

    // Static aur dynamic child routes dono match honge
    return (
      currentPath === route ||
      currentPath.startsWith(`${route}/`)
    );
  });
};

const Header = ({
  showMenu,
  openSideMenu,
  closeSideMenu,
  handleToggleMenu,
  isMobile,
  whatsappNum,
  setEventType,
}) => {
  // const navigate = useNavigate();
  // const userInfo = Helper();
  // const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath =
    location.pathname
      .replace(/\/+$/, "")
      .toLowerCase() || "/";

  const showDesktopNavigation = isRouteVisible(
    currentPath,
    DESKTOP_NAV_VISIBLE_ROUTES
  );

  const showLiveMatches = isRouteVisible(
    currentPath,
    LIVE_MATCHES_VISIBLE_ROUTES
  );

  const {
    user,
    isAuthenticated,
    logout,
  } = useAuth();

  const userInfo =
    isAuthenticated && user ? user : null;
  const betData = useSelector((state) => state.data); // Use selector to access state
  const eventStore = useSelector(
    (state) => state.events
  );
  const dispatch = useDispatch();
  UserAutoLogout();
  const [showOffcanvas, setShowOffcanvas] = useState(false); // Right slider
  const [showAccountMenu, setShowAccountMenu] =
    useState(false);

  const [showHeaderBalance, setShowHeaderBalance] =
    useState(() => {
      return (
        localStorage.getItem("showHeaderBalance") !==
        "false"
      );
    });

  const [showHeaderExposure, setShowHeaderExposure] =
    useState(() => {
      return (
        localStorage.getItem("showHeaderExposure") !==
        "false"
      );
    });

  const accountMenuRef = useRef(null);
  // const [showMenu, setShowMenu] = useState(false); // Left slider
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const [showMyMarkets, setShowMyMarkets] = useState(false);

  const [
    myMarketRows,
    setMyMarketRows,
  ] = useState([]);

  const [
    myMarketLoading,
    setMyMarketLoading,
  ] = useState(false);

  const openMyMarketsPopup = useCallback(
    (event) => {
      /*
       * Exposure parent account button ke andar hai,
       * isliye account menu click ko stop karo.
       */
      event?.preventDefault();
      event?.stopPropagation();

      setShowAccountMenu(false);
      setShowMyMarkets(true);
    },
    []
  );

  const closeMyMarketsPopup = useCallback(() => {
    setShowMyMarkets(false);
  }, []);

  const getEventTypeName = useCallback(
    (eventType, fallbackName) => {
      const normalizedType =
        Number(eventType);

      const eventTypeNames = {
        1: "Football",
        2: "Tennis",
        4: "Cricket",
        7: "Horse Racing",
        4339: "Greyhound Racing",
      };

      return (
        eventTypeNames[normalizedType] ||
        fallbackName ||
        "Sports"
      );
    },
    []
  );

  const loadMyMarkets = useCallback(
    async () => {
      const userId = userInfo?._id;

      if (!userId) {
        setMyMarketRows([]);
        return;
      }

      setMyMarketLoading(true);

      try {
        const response =
          await fetchOpenBetsApi({
            user_id: userId,
            request_time: Date.now(),
          });

        const apiBets =
          response?.data?.result &&
            Array.isArray(
              response?.data?.resultData
            )
            ? response.data.resultData
            : [];

        /*
         * Same event + same market ki multiple bets
         * ko ek row me group karo.
         */
        const groupedMarkets =
          new Map();

        apiBets.forEach((bet) => {
          const status = String(
            bet?.status || "Open"
          ).toLowerCase();

          const isDeleted =
            String(
              bet?.is_delete || "No"
            ).toLowerCase() === "yes";

          const isCancelled =
            String(
              bet?.is_cancel || "No"
            ).toLowerCase() === "yes";

          if (
            status === "settled" ||
            status === "cashedout" ||
            isDeleted ||
            isCancelled
          ) {
            return;
          }

          const matchId = String(
            bet?.match_id ??
            bet?.event_id ??
            ""
          );

          const marketId = String(
            bet?.market_id ?? ""
          );

          const groupKey = [
            matchId,
            marketId,
            bet?.market_name || "",
          ].join("_");

          const existingRow =
            groupedMarkets.get(groupKey);

          if (existingRow) {
            existingRow.tradeCount += 1;
            return;
          }

          const competitionName =
            bet?.competition_name ||
            bet?.competition ||
            bet?.series_name ||
            bet?.seriesName ||
            bet?.event_name ||
            "Sports Market";

          const matchName =
            bet?.match_name ||
            bet?.event_name ||
            bet?.market_name ||
            bet?.runner_name ||
            "Open Market";

          groupedMarkets.set(
            groupKey,
            {
              id:
                groupKey ||
                bet?._id ||
                bet?.betting_id,

              eventType:
                getEventTypeName(
                  bet?.event_type,
                  bet?.event_type_name
                ),

              eventName:
                competitionName,

              matchName:
                matchName,

              tradeCount: 1,

              matchId,
              marketId,

              marketName:
                bet?.market_name ||
                "",

              isInplay:
                Boolean(
                  bet?.is_inplay
                ),
            }
          );
        });

        setMyMarketRows(
          Array.from(
            groupedMarkets.values()
          )
        );
      } catch (error) {
        console.error(
          "Unable to load My Markets:",
          error?.response?.data ||
          error?.message ||
          error
        );

        setMyMarketRows([]);

        toast.error(
          "Unable to load My Markets."
        );
      } finally {
        setMyMarketLoading(false);
      }
    },
    [
      userInfo?._id,
      getEventTypeName,
    ]
  );

  useEffect(() => {
    if (!showMyMarkets) {
      return;
    }

    loadMyMarkets();
  }, [
    showMyMarkets,
    loadMyMarkets,
    betData,
  ]);

  const handleSelectMyMarket =
    useCallback(
      (row) => {
        const matchId =
          row?.matchId;

        if (!matchId) {
          toast.error(
            "Match ID is missing."
          );
          return;
        }

        closeMyMarketsPopup();

        const matchStatus =
          row?.isInplay
            ? "Inplay"
            : "Upcoming";

        navigate(
          `/matchupdates/${matchId}/${matchStatus}`
        );
      },
      [
        navigate,
        closeMyMarketsPopup,
      ]
    );

  const [showCricketList, setShowCricketList] = useState(false);
  const [showFootballList, setShowFootballList] = useState(false);
  const [showTennisList, setShowTennisList] = useState(false);
  const [showHorseRacingList, setShowHorseRacingList] = useState(false);
  const [showGrayHoundRacingList, setShowGrayHoundRacingList] = useState(false);
  const [showIndianCardGamesList, setShowIndianCardGamesList] = useState(false);
  const [showLoginModel, setShowLoginModel] = useState(false);
  const [showSignupModel, setShowSignupModel] = useState(false);
  const [showForgotModel, setShowForgotModel] = useState(false);
  // const [whatsappNum, setWhatsAppNumber] = useState("");
  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);

  const balanceRequestInFlightRef = useRef(false);

  const balanceWithExp = useMemo(() => {
    return (
      (Number(balance) || 0) -
      Math.abs(Number(exposure) || 0)
    );
  }, [balance, exposure]);
  const [
    headerLiveMatches,
    setHeaderLiveMatches,
  ] = useState([]);

  const [currentDate, setCurrentDate] = useState('');
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      // Format date as "Jul 1st, 2025"
      const day = now.getDate();
      const daySuffix = (d) => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      };
      const month = now.toLocaleString('default', { month: 'short' });
      const year = now.getFullYear();
      setCurrentDate(`${month} ${day}${daySuffix(day)}, ${year} ( GMT +5.5:30 )`);

      // Format time as HH:mm:ss
      setCurrentTime(now.toLocaleTimeString('en-GB', { hour12: false }));
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchHeaderEvents = () => {
      dispatch(
        getAllEvents({
          user_id: userInfo?._id || "",
        })
      );
    };

    // Header mount hote hi events fetch honge.
    fetchHeaderEvents();

    /*
     * Live matches refresh karne ke liye har
     * 15 seconds mein list update hogi.
     */
    const intervalId = window.setInterval(
      fetchHeaderEvents,
      15000
    );

    return () => {
      window.clearInterval(intervalId);
    };
  }, [dispatch, userInfo?._id]);

  const [showRulesModal, setShowRulesModal] = useState(false);

  const openRulesModal = useCallback(() => {
    setShowAccountMenu(false);
    setShowRulesModal(true);
  }, []);

  const closeRulesModal = useCallback(() => {
    setShowRulesModal(false);
  }, []);

  const freshHeaderLiveMatches = useMemo(() => {
    const eventGroups = Array.isArray(
      eventStore?.events
    )
      ? eventStore.events
      : [];

    /*
     * Store structure:
     * events → competitions → events
     */
    const allEvents = eventGroups
      .flatMap(
        (eventGroup) =>
          eventGroup?.competitions || []
      )
      .flatMap(
        (competition) =>
          competition?.events || []
      );

    const uniqueEvents = Array.from(
      new Map(
        allEvents.map((event) => [
          String(
            event?.event_id ||
            event?.eventId ||
            event?._id
          ),
          event,
        ])
      ).values()
    );

    const isLiveEvent = (event) => {
      const inPlayValue =
        event?.is_inplay ??
        event?.isInplay ??
        event?.isInPlay;

      return (
        inPlayValue === true ||
        inPlayValue === 1 ||
        inPlayValue === "1" ||
        String(inPlayValue).toLowerCase() ===
        "true"
      );
    };

    const getEventType = (event) =>
      String(
        event?.event_type ??
        event?.eventType ??
        event?.event_type_id ??
        ""
      );

    const liveEvents =
      uniqueEvents.filter(isLiveEvent);

    /*
     * Event types from your MatchUpdates code:
     * 4 = Cricket
     * 2 = Tennis
     * 1 = Football
     */
    const cricketMatches = liveEvents
      .filter(
        (event) => getEventType(event) === "4"
      )
      .slice(0, 2)
      .map((event) => ({
        ...event,
        tickerSport: "cricket",
      }));

    const tennisMatches = liveEvents
      .filter(
        (event) => getEventType(event) === "2"
      )
      .slice(0, 2)
      .map((event) => ({
        ...event,
        tickerSport: "tennis",
      }));

    const footballMatches = liveEvents
      .filter(
        (event) => getEventType(event) === "1"
      )
      .slice(0, 2)
      .map((event) => ({
        ...event,
        tickerSport: "football",
      }));

    return [
      ...cricketMatches,
      ...tennisMatches,
      ...footballMatches,
    ];
  }, [eventStore?.events]);

  useEffect(() => {
    /*
     * Redux refetch ke samay list temporarily
     * empty ho toh existing matches clear
     * nahi honge.
     */
    if (
      freshHeaderLiveMatches.length === 0
    ) {
      return;
    }

    setHeaderLiveMatches(
      freshHeaderLiveMatches
    );
  }, [freshHeaderLiveMatches]);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 991);
  //     if (window.innerWidth > 991) {
  //       setShowMenu(true); // Always show sidebar on desktop
  //     } else {
  //       setShowMenu(false); // Hide sidebar on mobile
  //     }
  //   };
  //   window.addEventListener("resize", handleResize);
  //   handleResize();
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  useEffect(() => {
    console.log("userInfo", userInfo);
  }, [userInfo]);

  const getBalance = useCallback(async () => {
    const userId = userInfo?._id;

    if (!userId || balanceRequestInFlightRef.current) {
      return;
    }

    balanceRequestInFlightRef.current = true;

    try {
      const response = await axios.post(
        `${Appconfig.apiUrl}ledger/getUserBalance`,
        {
          user_id: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = response?.data;

      if (
        responseData?.result === 0 ||
        responseData?.result === false
      ) {
        return;
      }

      const resultData = responseData?.resultData || {};

      const updatedBalance = Number(resultData?.balance);
      const updatedExposure = Number(resultData?.exposure);

      if (Number.isFinite(updatedBalance)) {
        setBalance(updatedBalance);
      }

      if (Number.isFinite(updatedExposure)) {
        setExposure(updatedExposure);
      }
    } catch (error) {
      console.error(
        "Unable to refresh user balance:",
        error?.response?.data || error?.message || error
      );
    } finally {
      balanceRequestInFlightRef.current = false;
    }
  }, [userInfo?._id]);

  useEffect(() => {
    if (!userInfo?._id) {
      setBalance(0);
      setExposure(0);
      return undefined;
    }

    // Header mount hote hi balance load hoga.
    getBalance();

    // Polling aur browser events ke liye common function.
    const refreshBalance = () => {
      if (
        document.visibilityState === "visible" &&
        navigator.onLine
      ) {
        getBalance();
      }
    };

    // Har 3 seconds latest balance fetch karega.
    const balanceIntervalId = window.setInterval(
      refreshBalance,
      3000
    );

    // Hidden tab se visible tab par aane par refresh.
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        getBalance();
      }
    };

    // Deposit/Withdraw files se dispatch kiya gaya event.
    const handleCustomBalanceUpdate = () => {
      getBalance();
    };

    // Browser/app par wapas focus aane par.
    window.addEventListener("focus", refreshBalance);

    // Internet reconnect hone par.
    window.addEventListener("online", refreshBalance);

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange
    );

    // Custom balance refresh listener.
    window.addEventListener(
      "balance:update",
      handleCustomBalanceUpdate
    );

    // Component unmount hone par listeners remove honge.
    return () => {
      window.clearInterval(balanceIntervalId);

      window.removeEventListener(
        "focus",
        refreshBalance
      );

      window.removeEventListener(
        "online",
        refreshBalance
      );

      document.removeEventListener(
        "visibilitychange",
        handleVisibilityChange
      );

      window.removeEventListener(
        "balance:update",
        handleCustomBalanceUpdate
      );
    };
  }, [userInfo?._id, getBalance]);

  useEffect(() => {
    if (!userInfo?._id) {
      return;
    }

    getBalance();
  }, [betData, userInfo?._id, getBalance]);

  // const handleLogout = () => {
  //   handleClose();
  //   logout();
  // };

  const handleLogout = () => {
    handleClose();
    closeAccountMenu();
    logout();
    navigate("/login", { replace: true });
  };

  // const handleToggleMenu = () => {
  //   if (showOffcanvas) {
  //     setShowOffcanvas(false); // Close the right slider if it's open
  //   }
  //   setShowMenu(!showMenu);
  // };

  const handleUserClick = () => {
    if (showMenu) {
      handleToggleMenu(); // ✅ Use the prop!
    }
    setShowOffcanvas(true);
  };

  const handleClose = () => {
    setShowOffcanvas(false);
  };

  const toggleAccountMenu = () => {
    closeSideMenu?.();

    setShowAccountMenu((previous) => !previous);
  };

  const closeAccountMenu = () => {
    setShowAccountMenu(false);
  };

  const toggleHeaderBalance = () => {
    setShowHeaderBalance((previous) => {
      const nextValue = !previous;

      localStorage.setItem(
        "showHeaderBalance",
        String(nextValue)
      );

      return nextValue;
    });
  };

  const toggleHeaderExposure = () => {
    setShowHeaderExposure((previous) => {
      const nextValue = !previous;

      localStorage.setItem(
        "showHeaderExposure",
        String(nextValue)
      );

      return nextValue;
    });
  };

  const openAccountPage = (path) => {
    closeAccountMenu();
    navigate(path);
  };

  const openDesktopNavigation = (item) => {
    // 1. Cricket, football, tennis etc. filter
    if (
      item.eventType !== undefined &&
      typeof setEventType === "function"
    ) {
      setEventType(item.eventType);
      return;
    }

    // 2. Direct WCO casino launch
    if (item.wcoGame) {
      if (!userInfo?._id) {
        setShowLoginModel(true);
        return;
      }

      const {
        providerCode,
        gameCode,
        type,
      } = item.wcoGame;

      CreateAndLaunchWCOCasino(
        providerCode,
        gameCode,
        type
      );

      return;
    }

    // 3. Normal page navigation
    if (item.path) {
      navigate(item.path);
    }
  };

  useEffect(() => {
    if (!showAccountMenu) return undefined;

    const handleOutsideClick = (event) => {
      if (
        accountMenuRef.current &&
        !accountMenuRef.current.contains(event.target)
      ) {
        closeAccountMenu();
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        closeAccountMenu();
      }
    };

    document.addEventListener(
      "mousedown",
      handleOutsideClick
    );

    document.addEventListener(
      "touchstart",
      handleOutsideClick
    );

    document.addEventListener(
      "keydown",
      handleEscapeKey
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );

      document.removeEventListener(
        "touchstart",
        handleOutsideClick
      );

      document.removeEventListener(
        "keydown",
        handleEscapeKey
      );
    };
  }, [showAccountMenu]);

  const handleLoginPopupClick = () => {
    setShowLoginPopup(true); // Show the login popup
  };

  const handleLoginPopupClose = () => {
    setShowLoginPopup(false); // Hide the login popup
  };

  const handleDeposit = () => {
    setShowDeposit(true);
    navigate("/deposit");
  };
  const handleMyMarkets = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleAviator = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`SPB`, `aviator`);
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleCricketList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleFootballList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleTennisList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleHorseRacingList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleGrayHoundRacingList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleIndianCardGamesList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  async function CreateAndLaunchWCOCasino(
    providerCode,
    gameCode = "",
    type = null
  ) {
    if (!userInfo?._id || !userInfo?.user_name) {
      setShowLoginModel(true);
      return;
    }

    try {
      const userData = {
        user_id: userInfo._id,
        user_name: userInfo.user_name,
        redirect_url: window.location.origin,
        provider_code: providerCode,
        game_code: gameCode || "",
        ...(type ? { type } : {}),
      };

      const response = await axios.post(
        `${Appconfig.casinoUrl}wco/login`,
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const status = response.data?.status?.code;
      const message = response.data?.status?.message;
      const launchURL = response.data?.launchURL;

      if (status === "SUCCESS" && launchURL) {
        window.location.assign(launchURL);
        return;
      }

      if (
        status === "VALIDATION_ERROR" ||
        status === "UNKNOWN_ERROR"
      ) {
        toast.error(message || "Game Not Found.", {
          autoClose: 2000,
        });
        return;
      }

      if (
        status === "AUTHENTICATION_FAILED" ||
        status === "LOGIN_FAILED"
      ) {
        toast.error(
          message || "Casino login failed.",
          {
            autoClose: 2000,
          }
        );
        return;
      }

      toast.error(message || "Unable to launch game.", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Casino launch error:", error);

      toast.error(
        error.response?.data?.status?.message ||
        "Casino server is not responding.",
        {
          autoClose: 2000,
        }
      );
    }
  }

  function OpenEzugiLobby(casinoType) {
    handleToggleMenu();
    navigate("/all-games-lobby", { state: { activeCasino: casinoType } });
  }

  // const getWhatsAppNumber = () => {
  //   var data = JSON.stringify({
  //     site_code: Appconfig.sitecodes,
  //   });
  //   var config = {
  //     method: "post",
  //     url: `${Appconfig.apiUrl}numbers/getNumberBySiteCode`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };
  //   axios(config)
  //     .then(function (response) {
  //       try {
  //         if (response.data.result) {
  //           setWhatsAppNumber(response.data?.resultData?.mob_num);
  //         }
  //       } catch (e) {
  //         // postErrorToslack(e.message);
  //       }
  //     })
  //     .catch(function (error) {
  //       // postErrorToslack(error.message);
  //       console.log(error);
  //     });
  // };

  const openWhatsApp = (whatsapp) => {
    const url = `https://wa.me/${whatsapp.replace(/\D/g, "")}`;
    window.open(url, "_blank");
  };

  const getHeaderMatchName = (match) => {
    return (
      match?.event_name ||
      match?.eventName ||
      match?.name ||
      match?.match_name ||
      "Live match"
    );
  };

  const getHeaderMatchId = (match) => {
    return (
      match?.event_id ||
      match?.eventId ||
      match?._id
    );
  };

  const openHeaderLiveMatch = (match) => {
    const matchId =
      getHeaderMatchId(match);

    if (!matchId) {
      console.error(
        "Live match event ID missing:",
        match
      );

      return;
    }

    navigate(
      `/matchupdates/${matchId}/True`
    );
  };

  const checkNewLogin = () => {
    var data = JSON.stringify({
      login_token: userInfo.login_token,
      user_id: userInfo._id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}userToken/getToken`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          if (response.data.result) {
          } else {
            localStorage.clear();
            localStorage.removeItem("userdata");
            dispatch(emptyUserInfo());
            localStorage.removeItem("login_token");
            window.location.href = "/";
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        // postErrorToslack(error.message);
        console.log(error);
      });
  };

  // useEffect(() => {
  //   getWhatsAppNumber();
  // }, []);

  // useEffect(() => {
  //   const chkLog = window.setInterval(function () {
  //     if (userInfo) {
  //       checkNewLogin();
  //     }
  //   }, 5000);
  //   return () => {
  //     clearInterval(chkLog)
  //   }
  // }, [])

  const togglePopup = (isClose = null) => {
    if (isClose == "Yes") {
      setShowLoginModel(false);
    } else {
      setShowLoginModel(!showLoginModel);
    }
    setShowForgotModel(false);
    setShowSignupModel(false);
    // setShowMenu(false);
  };

  const toggleForgotPopup = () => {
    setShowLoginModel(false);
    setShowSignupModel(false);
    setShowForgotModel(!showForgotModel);
    // setShowMenu(false);
  };

  const toggleSignUpPopup = () => {
    setShowLoginModel(false);
    setShowForgotModel(false);
    setShowSignupModel(!showSignupModel);
    // setShowMenu(false);
  };

  return (
    <>
      {/* <Login
        showPopup={showLoginModel}
        togglePopup={togglePopup}
        whatsappNum={whatsappNum}
        openWhatsApp={openWhatsApp}
        toggleForgotPopup={toggleForgotPopup}
        toggleSignUpPopup={toggleSignUpPopup}
        handleClose={handleClose}
      /> */}
      <ForgotPassword
        showForgotPopup={showForgotModel}
        togglePopup={togglePopup}
        toggleForgotPopup={toggleForgotPopup}
        handleClose={handleClose}
      />
      <SignUp
        showSignupPopup={showSignupModel}
        togglePopup={togglePopup}
        whatsappNum={whatsappNum}
        openWhatsApp={openWhatsApp}
        toggleSignUpPopup={toggleSignUpPopup}
        handleClose={handleClose}
      />

      {isMobile ? (
        <div className="reference-mobile-header-stack">
          {/* Row 1: Logo, balance and account */}
          <header className="reference-mobile-header">
            <div className="reference-header-brand">
              {/* <button
                type="button"
                className="reference-hamburger"
                onClick={handleToggleMenu}
                aria-label="Open navigation menu"
              >
                <span />
                <span />
                <span />
              </button> */}

              <button
                type="button"
                className="reference-hamburger"
                onClick={openSideMenu}
                aria-label="Open navigation menu"
                aria-expanded={showMenu}
              >
                <i
                  className="fas fa-bars"
                  aria-hidden="true"
                />
              </button>

              <Link
                to="/"
                className="reference-logo-link"
              >
                <img
                  src="/Images/logo.png"
                  alt="BMW EXCH"
                  className="reference-mobile-logo"
                />
              </Link>
            </div>

            {userInfo ? (
              <div
                className="reference-account-area"
                ref={accountMenuRef}
              >
                <button
                  type="button"
                  className="reference-account-summary"
                  onClick={toggleAccountMenu}
                  aria-haspopup="menu"
                  aria-expanded={showAccountMenu}
                >
                  {showHeaderBalance && (
                    <span className="reference-balance">
                      Balance:
                      <strong>
                        {Number(
                          balanceWithExp || 0
                        ).toFixed(0)}
                      </strong>
                    </span>
                  )}

                  <span className="reference-account-bottom">
                    {showHeaderExposure && (
                      <span
                        className="reference-exposure reference-exposure-clickable"
                        role="button"
                        tabIndex={0}
                        title="View My Market"
                        onClick={openMyMarketsPopup}
                        onKeyDown={(event) => {
                          if (
                            event.key === "Enter" ||
                            event.key === " "
                          ) {
                            openMyMarketsPopup(event);
                          }
                        }}
                      >
                        Exp:
                        <strong>
                          {Number(
                            exposure || 0
                          ).toFixed(0)}
                        </strong>
                      </span>
                    )}

                    <span className="reference-username">
                      {userInfo?.user_name || "User"}
                    </span>

                    <i
                      className={[
                        "fas",
                        "fa-chevron-down",
                        "ms-1",
                        "reference-account-chevron",
                        showAccountMenu
                          ? "reference-account-chevron-open"
                          : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      aria-hidden="true"
                    />
                  </span>
                </button>

                {showAccountMenu && (
                  <div
                    className="reference-account-dropdown"
                    role="menu"
                  >
                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() =>
                        openAccountPage("/account-statement")
                      }
                      role="menuitem"
                    >
                      Account Statement
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() => openAccountPage("/deposit")}
                      role="menuitem"
                    >
                      Deposit
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() => openAccountPage("/withdraw")}
                      role="menuitem"
                    >
                      Withdraw
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() =>
                        openAccountPage("/openbets")
                      }
                      role="menuitem"
                    >
                      Current Bet
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() =>
                        openAccountPage("/casino-results")
                      }
                      role="menuitem"
                    >
                      Casino Results
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() =>
                        openAccountPage("/set-button-values")
                      }
                      role="menuitem"
                    >
                      Set Button Values
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={openRulesModal}
                      role="menuitem"
                      aria-haspopup="dialog"
                    >
                      Rules
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item reference-account-toggle"
                      onClick={toggleHeaderBalance}
                      role="menuitemcheckbox"
                      aria-checked={showHeaderBalance}
                    >
                      <span>Balance</span>

                      <span
                        className={[
                          "reference-account-check",
                          showHeaderBalance
                            ? "reference-account-check-active"
                            : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        aria-hidden="true"
                      >
                        {showHeaderBalance && (
                          <i className="fas fa-check" />
                        )}
                      </span>
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item reference-account-toggle"
                      onClick={toggleHeaderExposure}
                      role="menuitemcheckbox"
                      aria-checked={showHeaderExposure}
                    >
                      <span>Exposure</span>

                      <span
                        className={[
                          "reference-account-check",
                          showHeaderExposure
                            ? "reference-account-check-active"
                            : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        aria-hidden="true"
                      >
                        {showHeaderExposure && (
                          <i className="fas fa-check" />
                        )}
                      </span>
                    </button>

                    <div className="reference-account-divider" />

                    <button
                      type="button"
                      className="reference-account-menu-item reference-signout-item"
                      onClick={handleLogout}
                      role="menuitem"
                    >
                      SignOut
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button
                type="button"
                className="reference-login-button"
                onClick={() =>
                  navigate("/login")
                }
              >
                Login
              </button>
            )}
          </header>

          {/* Row 2: News */}
          <section
            className="reference-news-ticker"
            aria-label="Latest news"
          >
            <div className="reference-news-icon">
              {/* Search icon */}
              <i className="fas fa-search-plus" />
            </div>

            <div className="reference-news-window">
              <div className="reference-news-track">
                <span>
                  Newly Launched Matka Market In Our Exchange
                </span>

                <span aria-hidden="true">
                  Newly Launched Matka Market In Our Exchange
                </span>
              </div>
            </div>
          </section>

          {/* Row 3: Only live matches */}
          {/* Row 3: Live-match section always visible */}
          {showLiveMatches && (
            <section
              className="header-live-matches"
              aria-label="Live matches"
            >
              <div className="header-live-track">
                {headerLiveMatches.length > 0 ? (
                  headerLiveMatches.map((match, index) => {
                    const matchId =
                      getHeaderMatchId(match);

                    const matchName =
                      getHeaderMatchName(match);

                    return (
                      <button
                        key={
                          matchId ||
                          `${match.tickerSport}-${index}`
                        }
                        type="button"
                        className={[
                          "header-live-match",
                          `header-live-${match.tickerSport}`,
                        ].join(" ")}
                        onClick={() =>
                          openHeaderLiveMatch(match)
                        }
                        title={matchName}
                      >
                        <span className="header-live-blinking-content">
                          <span
                            className="header-live-sport-icon"
                            aria-hidden="true"
                          >
                            {match.tickerSport === "cricket" ? (
                              <i className="d-icon icon-4" />
                            ) : match.tickerSport === "tennis" ? (
                              <i className="d-icon icon-2" />
                            ) : (
                              <i className="d-icon icon-1" />
                            )}
                          </span>

                          <span className="header-live-name">
                            {matchName}
                          </span>
                        </span>
                      </button>
                    );
                  })
                ) : (
                  <div className="header-live-empty">
                    Live matches will appear here
                  </div>
                )}
              </div>
            </section>
          )}
        </div>
      ) : (
        <div className="reference-desktop-header-stack">
          <header className="reference-desktop-header">
            <Link
              to="/"
              className="reference-desktop-logo-link"
            >
              <img
                src="/Images/logo.png"
                alt="BMW EXCH"
                className="reference-desktop-logo"
              />
            </Link>

            {userInfo ? (
              <div className="reference-desktop-header-right">
                <button
                  type="button"
                  className="reference-desktop-search-button"
                  aria-label="Search"
                >
                  <i
                    className="fas fa-search-plus"
                    aria-hidden="true"
                  />
                </button>

                <button
                  type="button"
                  className="reference-desktop-rules-button"
                  onClick={openRulesModal}
                  aria-haspopup="dialog"
                  aria-expanded={showRulesModal}
                >
                  Rules
                </button>

                <div className="reference-desktop-totals">
                  {showHeaderBalance && (
                    <span>
                      Balance:
                      <strong>
                        {Number(
                          balanceWithExp || 0
                        ).toFixed(0)}
                      </strong>
                    </span>
                  )}

                  {showHeaderExposure && (
                    <span
                      className="reference-exposure reference-exposure-clickable"
                      role="button"
                      tabIndex={0}
                      title="View My Market"
                      onClick={openMyMarketsPopup}
                      onKeyDown={(event) => {
                        if (
                          event.key === "Enter" ||
                          event.key === " "
                        ) {
                          openMyMarketsPopup(event);
                        }
                      }}
                    >
                      Exp:
                      <strong>
                        {Number(
                          exposure || 0
                        ).toFixed(0)}
                      </strong>
                    </span>
                  )}
                </div>

                <div
                  className="reference-desktop-user-area"
                  ref={accountMenuRef}
                >
                  <button
                    type="button"
                    className="reference-desktop-user-button"
                    onClick={toggleAccountMenu}
                    aria-haspopup="menu"
                    aria-expanded={showAccountMenu}
                  >
                    <span className="reference-desktop-username">
                      {userInfo?.user_name || "User"}
                    </span>

                    <i
                      className={[
                        "fas",
                        "fa-chevron-down",
                        "reference-desktop-chevron",
                        showAccountMenu
                          ? "reference-desktop-chevron-open"
                          : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      aria-hidden="true"
                    />
                  </button>

                  {showAccountMenu && (
                    <div
                      className="reference-account-dropdown reference-desktop-account-dropdown"
                      role="menu"
                    >
                      <button
                        type="button"
                        className="reference-account-menu-item"
                        onClick={() =>
                          openAccountPage("/account-statement")
                        }
                      >
                        Account Statement
                      </button><button
                        type="button"
                        className="reference-account-menu-item"
                        onClick={() => openAccountPage("/deposit")}
                        role="menuitem"
                      >
                        Deposit
                      </button>

                      <button
                        type="button"
                        className="reference-account-menu-item"
                        onClick={() => openAccountPage("/withdraw")}
                        role="menuitem"
                      >
                        Withdraw
                      </button>



                      <button
                        type="button"
                        className="reference-account-menu-item"
                        onClick={() =>
                          openAccountPage("/openbets")
                        }
                      >
                        Current Bet
                      </button>

                      <button
                        type="button"
                        className="reference-account-menu-item"
                        onClick={() =>
                          openAccountPage("/casino-results")
                        }
                      >
                        Casino Results
                      </button>

                      <button
                        type="button"
                        className="reference-account-menu-item"
                        onClick={() =>
                          openAccountPage("/set-button-values")
                        }
                      >
                        Set Button Values
                      </button>

                      <button
                        type="button"
                        className="reference-account-menu-item"
                        onClick={openRulesModal}
                        aria-haspopup="dialog"
                      >
                        Rules
                      </button>

                      <button
                        type="button"
                        className="reference-account-menu-item reference-account-toggle"
                        onClick={toggleHeaderBalance}
                        role="menuitemcheckbox"
                        aria-checked={showHeaderBalance}
                      >
                        <span>Balance</span>

                        <span
                          className={[
                            "reference-account-check",
                            showHeaderBalance
                              ? "reference-account-check-active"
                              : "",
                          ]
                            .filter(Boolean)
                            .join(" ")}
                        >
                          {showHeaderBalance && (
                            <i className="fas fa-check" />
                          )}
                        </span>
                      </button>

                      <button
                        type="button"
                        className="reference-account-menu-item reference-account-toggle"
                        onClick={toggleHeaderExposure}
                        role="menuitemcheckbox"
                        aria-checked={showHeaderExposure}
                      >
                        <span>Exposure</span>

                        <span
                          className={[
                            "reference-account-check",
                            showHeaderExposure
                              ? "reference-account-check-active"
                              : "",
                          ]
                            .filter(Boolean)
                            .join(" ")}
                        >
                          {showHeaderExposure && (
                            <i className="fas fa-check" />
                          )}
                        </span>
                      </button>

                      <div className="reference-account-divider" />

                      <button
                        type="button"
                        className="reference-account-menu-item reference-signout-item"
                        onClick={handleLogout}
                      >
                        SignOut
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <button
                type="button"
                className="reference-desktop-login"
                onClick={() => navigate("/login")}
              >
                Login
              </button>
            )}
          </header>

          {showDesktopNavigation && (
            <nav
              className="reference-desktop-primary-nav"
              aria-label="Primary navigation"
            >
              <div className="reference-desktop-primary-track">
                {DESKTOP_NAV_ITEMS.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className={[
                      "reference-desktop-primary-item",
                      item.crash
                        ? "reference-desktop-crash-item"
                        : "",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                    onClick={() =>
                      openDesktopNavigation(item)
                    }
                  >
                    {item.crash && (
                      <img
                        src={`${process.env.PUBLIC_URL}/Images/crash-plane.svg`}
                        alt=""
                        className="reference-desktop-crash-plane"
                        aria-hidden="true"
                      />
                    )}

                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            </nav>
          )}
          {/* Desktop live matches */}
          {showLiveMatches && (
            <section
              className="desktop-header-live-matches"
              aria-label="Live matches"
            >
              <div className="desktop-header-live-track">
                {headerLiveMatches.length > 0 ? (
                  headerLiveMatches.map((match, index) => {
                    const matchId = getHeaderMatchId(match);
                    const matchName = getHeaderMatchName(match);

                    return (
                      <button
                        key={
                          matchId ||
                          `${match.tickerSport}-${index}`
                        }
                        type="button"
                        className={[
                          "desktop-header-live-match",
                          `desktop-header-live-${match.tickerSport}`,
                        ].join(" ")}
                        onClick={() => openHeaderLiveMatch(match)}
                        title={matchName}
                      >
                        <span className="desktop-header-live-blink">
                          <span
                            className="desktop-header-live-icon"
                            aria-hidden="true"
                          >
                            {match.tickerSport === "cricket" ? (
                              <i className="d-icon icon-4" />
                            ) : match.tickerSport === "tennis" ? (
                              <i className="d-icon icon-2" />
                            ) : (
                              <i className="d-icon icon-1" />
                            )}
                          </span>

                          <span className="desktop-header-live-name">
                            {matchName}
                          </span>
                        </span>
                      </button>
                    );
                  })
                ) : (
                  <div className="desktop-header-live-empty">
                    Live matches will appear here
                  </div>
                )}
              </div>
            </section>
          )}
        </div>
      )}

      {/* Offcanvas menu for mobile (Left Slider) */}
      {/* <Offcanvas show={showMenu} onHide={handleToggleMenu} placement="start"> */}
      {/* <Offcanvas
        show={showMenu}
        onHide={isMobile ? handleToggleMenu : undefined}
        placement="start"
        backdrop={isMobile}
        scroll={!isMobile}
        className={isMobile ? "" : "desktop-sidebar"}
        style={isMobile ? {} : { width: 250, position: 'fixed', top: 56, height: '100vh', zIndex: 1040 }}
      >
        <Offcanvas.Header closeButton>
        <Offcanvas.Header closeButton={isMobile}>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item active">
                <button className="nav-link" onClick={() => navigate('/openbets')}><FaRegEye size={30} color="black" style={{ marginRight: 10 }} />My markets</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleAviator}><FaRocket size={30} color="Orange" style={{ marginRight: 10 }} />Aviator</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/cricketlist')}><BiCricketBall size={30} color="#900C3F" style={{ marginRight: 10 }} />Cricket</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/football-list')}><BiFootball size={30} color="black" style={{ marginRight: 10 }} />Football</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/tennislist')}><BiSolidTennisBall size={30} color="green" style={{ marginRight: 10 }} />Tennis</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleHorseRacingList}><FaHorseHead size={30} color="black" style={{ marginRight: 10 }} />Horce Racing</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleGrayHoundRacingList}><FaHorse size={30} color="brown" style={{ marginRight: 10 }} />Grayhound Racing</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => CreateAndLaunchWCOCasino('EZ', '', '')}><ImSpades size={30} color="black" style={{ marginRight: 10 }} />Indian Card Games</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleIndianCardGamesList}><FaTrophy size={30} color="#ffd133" style={{ marginRight: 10 }} />Sportsbook (80+)</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/ezugiLobby')}><PiMonitorPlay size={30} color="black" style={{ marginRight: 10 }} />Casino</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/ezugiLobby', { state: { activeCasino: 'Spribe' } })}><FaDice size={30} color="red" style={{ marginRight: 10 }} />Slot Games</button>
              </li>
            </ul>
          </Nav>
          {showLoginPopup && <LoginPopup onClose={handleLoginPopupClose} />}
        </Offcanvas.Body>
      </Offcanvas> */}

      {/* Fullscreen Offcanvas for Account Status (Right Slider) */}
      {/* <Offcanvas
        show={showOffcanvas}
        onHide={handleClose}
        placement="end"
        className="offcanvas-fullscreen"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Account Status</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AccountStatus
            handleLogout={handleLogout}
            handleClose={handleClose}
            userInfo={userInfo}
          />
        </Offcanvas.Body>
      </Offcanvas> */}

      {/* <RightMenu /> */}
      {showOffcanvas && (
        <RightMenu
          open={showOffcanvas}
          onClose={() => setShowOffcanvas(false)}
          email={userInfo?.email || userInfo?.user_name || "User"}
          balance={balance}
          whatsappNum={whatsappNum}
          freeCash={balanceWithExp}
          netExposure={exposure}
        />
      )}

      {/* Sidebar Menu */}
      {/* {(showMenu || !isMobile) && (
        <SideMenu />
      )} */}

      <MyMarketPopup
        open={showMyMarkets}
        onClose={closeMyMarketsPopup}
        rows={myMarketRows}
        loading={myMarketLoading}
        onSelectMarket={handleSelectMyMarket}
      />

      <RulesModal
        open={showRulesModal}
        onClose={closeRulesModal}
      />
    </>
  );
};

export default Header;
